import { navigateTo } from 'utils/navigation'

import { URL_CONST } from './urlConsts'

// Django builds the demo during this navigation (several seconds); without the
// shell preloader the old page just sits frozen.
export const navigateToStaticDemo = () => {
  if (typeof window.showPreloader === 'function') window.showPreloader()
  navigateTo(URL_CONST.staticDemo.self)
}
